import './modal.scss';

import { Modal, type ModalProps } from 'antd';
import React from 'react';

type TCustomModalProps = {
  isModalOpen: boolean;
  handleOk: React.MouseEventHandler;
  handleCancel: (title: React.ReactNode | string) => void;
  children?: React.ReactElement | React.ReactNode;
  footer?: React.ReactNode; //| ModalFooterRender;
  title: React.ReactNode | string;
  mask?: ModalProps['mask'];
  editClass: string;
  width?: number;
};

export const CustomModal = ({
  isModalOpen,
  handleOk,
  handleCancel,
  children,
  footer,
  title,
  editClass,
  mask,
  width
}: TCustomModalProps) => {
  return (
    <Modal
      width={width}
      centered
      className={`CustomModal ${editClass}`}
      title={title}
      open={isModalOpen}
      mask={
        typeof mask === 'object'
          ? {
              closable: true,
              ...(mask ?? {})
            }
          : mask
      }
      onOk={handleOk}
      onCancel={() => handleCancel(title)}
      footer={footer}
    >
      {children}
    </Modal>
  );
};
